// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Shipping40Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Shipping40: FC<Shipping40Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="40"
            height="40"
        >
            <path d="M11.389 33.333c-1.39 0-2.542-.495-3.459-1.486-.916-.99-1.328-2.171-1.235-3.542H2.528l.61-2.777H7.82c.435-.51.958-.91 1.569-1.202a4.582 4.582 0 0 1 2-.437c.722 0 1.389.145 2 .437a4.708 4.708 0 0 1 1.57 1.202h7.819L26.5 9.444H7.695l.138-.597c.148-.648.47-1.174.966-1.576a2.66 2.66 0 0 1 1.729-.604h19.444l-1.597 6.944h5.097l4.833 6.444-1.638 8.25h-3.334c.093 1.37-.324 2.551-1.25 3.542-.925.99-2.083 1.486-3.472 1.486-1.389 0-2.541-.495-3.458-1.486-.917-.99-1.329-2.171-1.236-3.542H16.11c.093 1.37-.324 2.551-1.25 3.542-.926.99-2.083 1.486-3.472 1.486Zm15.07-11.389h8.652l.222-1.208-3.25-4.347h-4.347l-1.278 5.555Zm-.237-11.375.278-1.125-3.722 16.084.25-1.098 1.417-6.083 1.777-7.778ZM.89 21.93l.694-2.777h9.167l-.695 2.777H.89Zm3.333-6.083.695-2.778H15.75l-.695 2.778H4.222Zm7.167 14.708c.546 0 1.007-.192 1.382-.576.375-.384.562-.84.562-1.368 0-.546-.187-1.007-.562-1.382a1.879 1.879 0 0 0-1.382-.563c-.528 0-.984.188-1.368.563a1.856 1.856 0 0 0-.576 1.382c0 .528.192.984.576 1.368.384.384.84.576 1.368.576Zm17.222 0c.546 0 1.007-.192 1.382-.576.375-.384.562-.84.562-1.368 0-.546-.187-1.007-.562-1.382a1.878 1.878 0 0 0-1.382-.563c-.527 0-.984.188-1.368.563a1.856 1.856 0 0 0-.576 1.382c0 .528.192.984.576 1.368.384.384.84.576 1.368.576Z" />
        </svg>
    );
};

export default Shipping40;
